(function () {
  var checkboxSelector = '#subscriptionNewsletter';
  var maxAttempts = 50;
  var attemptDelay = 250;
  var attempts = 0;
  var overlay = null;
  var lastFocusedElement = null;
  var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function buildModal() {
    var existingOverlay = document.getElementById('sms-consent-overlay');
    if (existingOverlay) return existingOverlay;

    var modalOverlay = document.createElement('div');
    modalOverlay.className = 'sms-consent-overlay';
    modalOverlay.id = 'sms-consent-overlay';

    var modal = document.createElement('div');
    modal.className = 'sms-consent-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'sms-consent-title');

    var title = document.createElement('h3');
    title.className = 'sms-consent-title';
    title.id = 'sms-consent-title';
    title.textContent = 'SMS consent';

    var copy = document.createElement('p');
    copy.className = 'sms-consent-copy';
    copy.innerHTML =
      'By providing your mobile number and opting in, you consent to receive SMS messages. ' +
      'Message frequency may vary. Msg &amp; data rates may apply. Reply STOP to unsubscribe.';

    var actions = document.createElement('div');
    actions.className = 'sms-consent-actions';

    var acceptBtn = document.createElement('button');
    acceptBtn.type = 'button';
    acceptBtn.className = 'sms-consent-btn sms-consent-accept';
    acceptBtn.setAttribute('data-sms-modal-accept', 'true');
    acceptBtn.textContent = 'I Accept';

    var declineBtn = document.createElement('button');
    declineBtn.type = 'button';
    declineBtn.className = 'sms-consent-btn sms-consent-decline';
    declineBtn.setAttribute('data-sms-modal-decline', 'true');
    declineBtn.textContent = 'I Decline';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'sms-consent-close';
    closeBtn.setAttribute('aria-label', 'Close modal');
    closeBtn.setAttribute('data-sms-modal-close', 'true');
    closeBtn.innerHTML = '&times;';

    actions.appendChild(acceptBtn);
    actions.appendChild(declineBtn);

    modal.appendChild(title);
    modal.appendChild(copy);
    modal.appendChild(actions);
    modal.appendChild(closeBtn);

    modalOverlay.appendChild(modal);
    document.body.appendChild(modalOverlay);

    return modalOverlay;
  }

  function trapFocus(e) {
    if (!overlay || overlay.style.display !== 'flex' || e.key !== 'Tab') return;

    var focusable = overlay.querySelectorAll(focusableSelector);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openModal(triggerEl) {
    if (!overlay) return;

    lastFocusedElement = triggerEl || document.activeElement;
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    var acceptBtn = overlay.querySelector('[data-sms-modal-accept]');
    if (acceptBtn) acceptBtn.focus();

    document.addEventListener('keydown', trapFocus);
  }

  function closeModal() {
    if (!overlay) return;

    overlay.style.display = 'none';
    document.body.style.overflow = '';
    document.removeEventListener('keydown', trapFocus);

    if (lastFocusedElement) lastFocusedElement.focus();
  }

  function declineConsent(checkbox) {
    checkbox.checked = false;
    closeModal();
  }

  function bindEvents(checkbox) {
    var acceptBtn = overlay.querySelector('[data-sms-modal-accept]');
    var declineBtn = overlay.querySelector('[data-sms-modal-decline]');
    var closeBtn = overlay.querySelector('[data-sms-modal-close]');

    if (!acceptBtn || !declineBtn || !closeBtn) return;

    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        openModal(checkbox);
      }
    });

    acceptBtn.addEventListener('click', function (e) {
      e.preventDefault();
      checkbox.checked = true;
      closeModal();
    });

    declineBtn.addEventListener('click', function (e) {
      e.preventDefault();
      declineConsent(checkbox);
    });

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      declineConsent(checkbox);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        declineConsent(checkbox);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.style.display === 'flex') {
        declineConsent(checkbox);
      }
    });
  }

  function init() {
    attempts += 1;

    var checkbox = document.querySelector(checkboxSelector);

    if (!checkbox) {
      if (attempts < maxAttempts) {
        setTimeout(init, attemptDelay);
      }
      return;
    }

    if (checkbox.dataset.smsModalInitialized === 'true') return;
    checkbox.dataset.smsModalInitialized = 'true';

    overlay = buildModal();
    bindEvents(checkbox);
  }

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  boot();
})();